export class PaginationClass {
  constructor(
    public page = 1,
    public perPage = 20,
    public total = 0,
  ) {
    this.page = page
    this.perPage = perPage
    this.total = total
  }

  get hasNextPage() {
    return this.page * this.perPage < this.total
  }

  get hasPrevPage() {
    return this.page > 1
  }

  get totalPages() {
    return Math.ceil(this.total / this.perPage)
  }

  get nextPage() {
    return this.page + 1
  }

  get prevPage() {
    return this.page - 1
  }
}
